export function createCandidateIdentifier(candidate) {
  if (!candidate) return { fullName: '', email: '' };

  const name = candidate.name || candidate.fullName || '';
  const lastName = candidate.lastName || '';
  const email = candidate.email || candidate.source?.email || '';

  const fullName =
    name && lastName
      ? normalize(`${name} ${lastName}`)
      : normalize(candidate.fullName || '');

  return {
    fullName,
    email: normalize(email),
  };
}

export function normalize(str) {
  return (str || '').toLowerCase().trim().replace(/\s+/g, ' ');
}

export const isSameCandidate = (candidate1, candidate2) => {
  const id1 = createCandidateIdentifier(candidate1);
  const id2 = createCandidateIdentifier(candidate2);

  const emailMatch = id1.email && id2.email && id1.email === id2.email;
  const nameMatch =
    id1.fullName && id2.fullName && id1.fullName === id2.fullName;

  return nameMatch || emailMatch;
};
